import { RouteRecordRaw } from 'vue-router'
const UserManagerRouter: Array<RouteRecordRaw> = [
  {
    path: '/products',
    name: 'products',
    meta: {
      title: '商品库'
    },
    component: () => import('@/views/products/index.vue')
  }, {
    path: '/selectionHistory',
    name: 'selectionHistory',
    meta: {
      title: '已创建的选品单'
    },
    component: () => import('@/views/history/selection/index.vue')
  }, {
    path: '/selectionEdit',
    name: 'selectionEdit',
    meta: {
      title: '编辑选品单'
    },
    component: () => import('@/views/history/selection/edit/index.vue')
  }
  // {
  //   path: '/cart',
  //   name: 'shoppingCart',
  //   meta: {
  //     title: '我的选品'
  //   },
  //   component: () => import('@/views/cart/index.vue')
  // }
]
export default UserManagerRouter
